import { Link as LinkLi } from '@material-ui/core';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as LinkDom } from 'react-router-dom';
import { toggleVisibility } from '../../utils';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;

const Search = lazy(() => import(`globalcomponents/UI/SimpleSearch/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));

export default function SearchWrapper({ selectChange, vehicles, onRemove }) {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const i18n = useTranslation();
  const addVehicle = () => toggleVisibility('addUsers');
  return (
    <>
      <Search
        onChange={(e) => selectChange(e)}
        default={{
          vehicleFilteredList: vehicles.vehicleList,
          trailerFilteredList: vehicles?.trailerList,
        }}
        fromData
        placeHolder={i18n.t('vehicles.searchVehicleTrailer')}
        query={['unit_id', 'vin', 'driverNames', 'manufact']}
        id="searchVehicle"
        onRemove={onRemove}
      ></Search>
      {checkServiceProvider('searchWrapper_addVehicleIcon', SERVICE_PROVIDER, false) ? null : (
        <Icon
          src={mediaUrls?.addVehicle}
          primary
          onClick={() => addVehicle()}
          tooltip={i18n.t('common.add')}
          id="addVehiclesTarget"
        />
      )}
      <div id="addUsers" className="vehicleModal">
        <ul>
          {checkServiceProvider('searchWrapper_addVehicleLink', SERVICE_PROVIDER) && (
            <li>
              <LinkLi component={LinkDom} variant="body2" to={pageUrls.addVehicle}>
                {i18n.t('vehicles.addVehicle')}
              </LinkLi>
            </li>
          )}
          <li>
            <LinkLi component={LinkDom} variant="body2" to={pageUrls.addTrailer}>
              {i18n.t('vehicles.addTrailer')}
            </LinkLi>
          </li>
        </ul>
      </div>
    </>
  );
}
